
export const SINGLE_PARTY = "SP";
export const MULTI_PARTY = "MP";
export const VENDOR = "VP";
export const LIENHOLDER = "LH";

export const workflowTypeDisplay = {
	'SP': 'Individual',
	'MP': 'Multiple Party',
	'LH': 'Lienholder',
	'VP': 'Vendor',
};